import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CoreCurrencies from "../ISW-Core/Currencies";

import { Spinner } from "../Shared";

import { currencyActions } from "./actions/currencies.actions";
import { routeConstants } from "../../_constants";

export class CurrencyForm extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getCurrency();
  }

  componentWillUnmount() {
    this.props.resetCurrency();
  }

  getCurrency = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getCurrency(match.params.id);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.refs.currencyForm.reset();
      this.currencies.currencyCode.changeValue(null)
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  createRequest = data => {
    let request = { ...data };

    if (request.currency) {
      request = {
        name: request.currency.name,
        alphaCode: request.currency.alphaCode,
        numericCode: request.currency.numericCode
      };
      delete request.currency;
    }

    return request;
  };

  handleSubmit = data => {
    let requestBody = this.createRequest(data);

    const { match } = this.props;
    const hasParams = match.params && match.params.id;
    if (hasParams) {
      requestBody = {
        id: match.params.id,
        ...requestBody
      };
    }
    this.props.addCurrency(requestBody);
  };

  render() {
    const { canSubmit } = this.state;
    const { submitting, match, viewResponse, viewError, fetched } = this.props;
    const currency = viewResponse && fetched ? viewResponse.modelList[0] : null;
    const hasParams = match.params && match.params.id;
    return (
      <div>
        <Row>
          <Col sm="6">
            <Link className="btn btn-outline btn-primary" to={routeConstants.CURRENCIES.path}>
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                {hasParams ? "Edit" : "Add"} Currency
                <small>
                  {currency && hasParams ? `: ${currency.name}` : null}
                </small>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="4">
            {viewError ? (
              <Alert color="danger">
                <strong>Error:</strong> {viewError.message}
              </Alert>
            ) : (
              <Formsy
                ref="currencyForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                <CoreCurrencies
                  value={currency && hasParams ? currency.alphaCode : null}
                  disabled={submitting || hasParams}
                  name="currency"
                  innerRef={c => {
                    this.currencies = c;
                  }}
                />
                
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting}
                >
                  {submitting ? <Spinner /> : "Submit"}
                </Button>
              </Formsy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { submitting, submitted, request, response, error } = state.addCurrency;

  const {
    fetching,
    fetched,
    request: viewRequest,
    response: viewResponse,
    error: viewError
  } = state.viewCurrency;

  return {
    submitting,
    submitted,
    request,
    response,
    error,
    fetching,
    fetched,
    viewRequest,
    viewResponse,
    viewError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCurrency: bindActionCreators(currencyActions.addCurrency, dispatch),
    resetCurrency: bindActionCreators(currencyActions.resetCurrency, dispatch),
    getCurrency: bindActionCreators(currencyActions.getCurrency, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrencyForm);
